<template>
  <div style="padding: 0 15px;" @click="toggleClick">
    <i class="el-icon-s-fold" style="font-size: 20px" v-show="!isActive"></i>
    <i class="el-icon-s-unfold" style="font-size: 20px" v-show="isActive"></i>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleClick() {
      this.$emit('toggleClick')
    }
  }
}
</script>

<style scoped>
</style>